
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import React from 'react';
import DialogSlideHistoricoGuia from './DialogSlideHistoricoGuia';

const styles = theme => ({
  buttonOperation: {
    fontSize: 'small',
    margin: theme.spacing(0.25),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minWidth: theme.spacing(3),
    maxWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },
  badge: {
    top: '5%',
    right: 5,
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
    // The border color match the background color.
    // border: `2px solid ${
    //   theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
    // }`,
  },
});

class ButtonHistoricoGuia extends React.Component {
  state = {
    dialogOpen: false
  }

  handleClick = () => {
    this.setState({dialogOpen: true});
  }

  handleCloseDialog = () => {
    this.setState({dialogOpen: false});
  }

  render () {
    const { classes, title, historico } = this.props;

    return (
      historico && historico.length > 0 &&
      <React.Fragment>
          <Button
            color='secondary'
            className={classes.buttonOperation}
            title='Histórico da guia'
            onClick={this.handleClick}>
            <HistoryIcon />
          </Button>
        <DialogSlideHistoricoGuia
          open={this.state.dialogOpen}
          title={title}
          historico={historico}
          handleClose={this.handleCloseDialog}
        />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ButtonHistoricoGuia);
